import {getResponseChoices, getResponseReferences, parseClientSideActions, parseMarkdown} from "./parser";

export function getQueryParam(key) {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(key);
  //decodifico e ritorno
  return  decodeAndReturnValue(value);
}


function decodeAndReturnValue(value) {
  if (typeof value !== 'string') {
    return value;
  }
  try {
    return decodeURIComponent(value);
  } catch (e) {
    console.warn('Errore nella Decodifica', e);
    return value;
  }
}

export function scanUrl(key = '') {
  let qs = key;
  if (!qs) qs = 'ask'
  return getQueryParam(qs);
}

export function parseBotResponse(res) {
  if (!res) return {};

  const { references, collect_feedback } = getResponseReferences(res);

  return {
    message: parseMarkdown(res),
    clientSideActions: parseClientSideActions(res),
    references,
    collect_feedback,
    choices: getResponseChoices(res),
  };
}

